
import React, { useEffect } from "react";
import LeftArrow from "../../../shared/icons/icon-left-arrow-slider.svg"
import RightArrow from "../../../shared/icons/icon-right-arrow-slider.svg"
import createUniqueId from "../../helpers/createUniqueId";

const ImageSlider = ({ handleNext,
  handlePrev,
  getVisibleImages,
  activeIndex,
  currentIndex,
  handleThumbnailClick,
  totalImages,
  isArrowVisible,
  cssStyle,
  resetTransform,
  resetScale
}) => {

  useEffect(() => {
    resetTransform && resetTransform();
    resetScale && resetScale();

  }, [activeIndex])


  return (
    <div className={`image-slider ${cssStyle}`}>
      {isArrowVisible && <button
        className="nav-btn"
        onClick={handlePrev}
        disabled={activeIndex === 0}
      >
        <LeftArrow />
      </button>}
      <div className="thumbnails">
        {getVisibleImages().map((image, index) => (
          <img
            key={createUniqueId(image.url, index)}
            src={image.url}
            alt={image.alt}
            className={index + currentIndex === activeIndex ? "active" : ""}
            onClick={() => handleThumbnailClick(index + currentIndex)}
          />
        ))}
      </div>
      {isArrowVisible && <button
        className="nav-btn"
        onClick={handleNext}
        disabled={activeIndex >= totalImages - 1}
      >
        <RightArrow />
      </button>}
    </div>
  );
};
export default ImageSlider;